module.exports = __webpack_public_path__ + "fonts/RenaultLife-LightItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-LightItalic.ttf
// module id = 365
// module chunks = 0